module.exports = __webpack_public_path__ + "static/media/mortgage_icon.47548289.svg";